import { styled, Typography } from 'shared/Houston';

export const PositionLabel = styled(Typography)`
  color: ${({ theme }) => theme.neutralColor.low.medium};
  font-size: 0.75rem !important;
`;
